import {StyleSheet} from 'react-native';

import {grayscale} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 80,
    paddingBottom: 100,
  },
  emptyIcon: {
    fontSize: 60,
    color: grayscale,
    paddingBottom: 40,
  },
  emptyTitle: {
    marginBottom: 10,
  },
  emptyDescription: {
    width: 250,
    textAlign: 'center',
  },
});
